import { render, staticRenderFns } from "./CloseButtonBlackSvg.vue?vue&type=template&id=748bcd38&scoped=true&"
import script from "./CloseButtonBlackSvg.vue?vue&type=script&lang=ts&"
export * from "./CloseButtonBlackSvg.vue?vue&type=script&lang=ts&"
import style0 from "./CloseButtonBlackSvg.vue?vue&type=style&index=0&id=748bcd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bcd38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('748bcd38', component.options)
    } else {
      api.reload('748bcd38', component.options)
    }
    module.hot.accept("./CloseButtonBlackSvg.vue?vue&type=template&id=748bcd38&scoped=true&", function () {
      api.rerender('748bcd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/CloseButtonBlackSvg.vue"
export default component.exports